import { MenuOptionType } from "@dexteel/mesf-core";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { Edit as EditIcon } from "@mui/icons-material";
import { FileCopy as ContentCopyIcon } from "@mui/icons-material";
import { PlaylistAdd as PlaylistAddIcon } from "@mui/icons-material";
import { CatalogOperator } from "../models/operator";

type Props = {
  setOperator: (element: CatalogOperator) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  handleNewOperator: () => void;
};
export const useOperatorsOptionsFunctions = ({
  setOperator,
  setShowModal,
  handleNewOperator,
}: Props) => {
  const getMenuOptions = (data: CatalogOperator) => {
    let options: MenuOptionType[] = [
      {
        name: "New Operator",
        key: "new_element",
        onClick: () => {
          handleNewOperator();
        },
        icon: <PlaylistAddIcon />,
      },
    ];
    if (data) {
      options = options.concat([
        {
          name: "Edit Operator",
          key: "edit_element",
          onClick: () => {
            setOperator(data);
            setShowModal("edit");
          },
          icon: <EditIcon />,
        },
        {
          name: "Delete Operator",
          key: "delete_material",
          onClick: () => {
            setOperator(data);
            setShowModal("delete");
          },
          icon: <DeleteIcon />,
        },
        {
          name: "Duplicate Operator",
          key: "duplicate_material",
          onClick: () => {
            setOperator({
              ...data,
              OperatorName: `${data.OperatorName} - Copy`,
              OperatorId: null,
            });
            setShowModal("new");
          },
          icon: <ContentCopyIcon />,
        },
      ]);
    }
    return options;
  };
  return {
    getMenuOptions,
  };
};
